import React, { useState, useEffect, useContext } from "react";
import { Album, Photo, ThumbnailSelectionMode } from "./types";
import ajax from "superagent";
import Photos from "./Photos";
import "./styles/albums-list.css";
import { EventGalleryContext } from "./index";
import { withCartIdParam } from "../../utils/BrowserHelper";
import _ from "lodash";
import Photos2 from "./Photos2";
const leftArrIcon = require("./styles/left-arrow.svg");
import ContrastForegroundUtility from "../../utils/ContrastForegroundUtility";
import DownloadIcon from "./vectors/DownloadIcon";
const gssNewLoader = require("../../assets/gss-loader.gif");

const AlbumPhotos = ({
  album,
  toggleAlbum,
  eventPassword,
  canShowGuestEmailModal
}: {
  album: Album;
  toggleAlbum: (album: Album | null) => void;
  eventPassword: string;
  canShowGuestEmailModal: (photo: any) => boolean;
}) => {
  const [photos, setPhotos] = useState<Photo[]>([]);
  const [nextPage, setNextPage] = useState<number | null>(1);
  const [totalCount, setTotalCount] = useState(0);
  const context = useContext(EventGalleryContext);

  useEffect(() => {
    if (context.reset === true) {
      setNextPage(1);
      setTotalCount(0);
    }
  }, [context.reset]);

  useEffect(() => {
    if (nextPage === 1 && context.guestUserId) {
      loadPhotos(true);
    } else if (nextPage === 1) {
      loadPhotos(false);
    }
  }, [nextPage]);

  useEffect(() => {
    const updatedPhotos = galleryPhotos(photos);
    setPhotos(updatedPhotos);
    context.setPhotos(updatedPhotos);
  }, [context.listOfMediaId.length, context.cart?.photos.length]);

  // This is used only by Photos2.tsx
  const [isLoading, setIsLoading] = useState(false);

  const loadPhotos = async (reset: boolean = false) => {
    if (isLoading || nextPage === null) return;
    setIsLoading(true);

    await photosRequest(
      album.links.photos,
      nextPage,
      context.cart ? context.cart.id : null,
      eventPassword
    )
      .then(response => {
        setPhotos(previousPhotos => {
          const photos = _.concat(
            context.reset || reset ? [] : previousPhotos,
            response.body.photos
          );
          return galleryPhotos(photos);
        });
        setNextPage(response.body.meta.nextPage);
        setTotalCount(response.body.meta.totalCount);
        context.reloadAlbumPhotos(false);
      })
      .catch(err => console.log(err))
      .finally(() => {
        setIsLoading(false);
      });
  };

  const photosRequest = async (
    link: string,
    nextPage: number | null,
    cartId: number,
    eventPassword: string
  ) => {
    let req = ajax.get(withCartIdParam(link, cartId)).query({
      page: nextPage,
      user_id: context.userId || context.guestUserId
    });

    if (eventPassword !== "") {
      req = req.query({
        event_password: eventPassword
      });
    }

    return req;
  };

  const shouldShowDownload = () => {
    return context.event.price === 0 && context.directDownloadEnabled;
  };

  const isSelected = (photo: Photo) => {
    return _.includes(
      context.curationMode || shouldShowDownload()
        ? context.listOfMediaId.map(item => item.id)
        : context.cart
        ? context.cart.photos
        : [],
      photo.id
    );
  };

  const galleryPhotos = (photos: any) => {
    return photos.map((photo: any) => {
      return {
        ...photo,
        ...(photo.timeTaken
          ? {
              tags: [
                {
                  title: "Time",
                  value: photo.timeTaken
                }
              ]
            }
          : {}),
        isSelected: isSelected(photo),
        src: "",
        disableContextMenu: true
      };
    });
  };

  const isAlbumV2Enabled =
    typeof window !== "undefined" && window.gss?.albumV2Enabled;

  const albumDownloadCTA = () => {
    const selectedPhotosCount = context.listOfMediaId.length;
    const freeEvent = context.event.price === 0;

    if (context.curationMode || !freeEvent || !context.directDownloadEnabled) {
      return null;
    }

    const handleDownloadAction = () => {
      const userId = context?.userId || context?.guestUserId;
      const isAuthorizedGallery = userId || context?.securedGalleryView;

      isAuthorizedGallery
        ? context.handleDownload(context.listOfMediaId)
        : context.setCollectDownloadEmailModal(true);
    };

    return (
      <div className="checkout ns">
        <button
          className={
            "ev-gallery-download-btn " +
            (selectedPhotosCount > 0 ? "secondary-btn" : "disable-btn")
          }
          disabled={context.downloadProcessing || selectedPhotosCount === 0}
          onClick={() => handleDownloadAction()}
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "10px"
          }}
        >
          <DownloadIcon
            color={ContrastForegroundUtility.fgColor(
              context.pageConfiguration.secondaryColor
            )}
            style={{ width: "16px", height: "12px" }}
          />

          <span
            className="photos"
            style={{
              color: ContrastForegroundUtility.fgColor(
                context.pageConfiguration.secondaryColor
              )
            }}
          >
            &nbsp;{selectedPhotosCount}{" "}
            <span className="cta-label-divider">|</span> Download
          </span>
        </button>
      </div>
    );
  };

  return (
    <div>
      <div className="egm-album-selected-div">
        <div className="d-flex">
          <button
            className="egm-album-back-btn"
            onClick={() => toggleAlbum(null)}
          >
            <img src={leftArrIcon} />
          </button>
          <div>
            <p className="egm-album-selected-name">{album.name}</p>
            <p className="egm-album-count">
              <span className="egm-count">{album.photosCount} photos</span>{" "}
              {!context.hidePhotographersFilter && (
                <span>
                  &#8226;&nbsp; by{" "}
                  <a
                    href={`mailto:${album.photographerEmail}?cc=support@geosnapshot.com&subject=Customer contact about event: ${album.eventName}`}
                  >
                    <span className="egm-pgrapher">
                      {album.photographerName}
                    </span>
                  </a>
                </span>
              )}
            </p>
          </div>
        </div>
        {albumDownloadCTA()}
      </div>
      {photos.length === 0 && isLoading && (
        <div className="egm-loader gss-loader" style={{ clear: "both" }}>
          <img className="photos-date-img" src={gssNewLoader} />
        </div>
      )}
      {photos &&
        (isAlbumV2Enabled && !context.curationMode ? (
          <Photos2
            photos={photos}
            windowingProps={{
              hasMore: nextPage !== null || photos.length < totalCount,
              isLoading: isLoading,
              loadMore: () => {
                if (nextPage !== null) loadPhotos(false);
              }
            }}
            selectionMode={ThumbnailSelectionMode.CART}
            isMobile={true}
            event={context.event}
            album={album}
            trackTelemetry={true}
            userId={context.userId ? context.userId : undefined}
            isAuthorizedForDirectDownloads={false}
            parentName={"event-gallery-lightbox"}
            showFavIcon={true}
            canShowGuestEmailModal={canShowGuestEmailModal}
            galleryPhotos={photos => galleryPhotos(photos)}
            setGuestUserId={context.setGuestUserId}
            securedOrgView={context.securedGalleryView}
            registerGuestUserAPI={context.registerGuestUserAPI}
          />
        ) : (
          <Photos
            photos={photos}
            loadPhotos={loadPhotos}
            hasMore={!!nextPage}
            trackTelemetry={true}
            userId={context.userId ? context.userId : undefined}
            isAuthorizedForDirectDownloads={false}
            parentName={"event-gallery-lightbox"}
            showFavIcon={true}
            canShowGuestEmailModal={canShowGuestEmailModal}
          />
        ))}
    </div>
  );
};

export default AlbumPhotos;
